export type MenteeStatusValues =
  | 'FILLING_FORM'
  | 'REFUSED_MENTORSHIP'
  | 'SIGNING_CHART'
  | 'ELIGIBLE'
  | 'REFUSED'
  | 'MENTORSHIP_ACTIVE';

enum MENTEE_STATUS {
  FILLING_FORM = 'Complète le questionnaire',
  REFUSED_MENTORSHIP = 'Refus du mentorat',
  SIGNING_CHART = 'En attente de validation de la charte',
  ELIGIBLE = 'Admissible',
  REFUSED = 'Refus du mentorat',
  MENTORSHIP_ACTIVE = 'En cours de mentorat',
}
export default MENTEE_STATUS;
